/*Main functions for the tool are located here*/

var findCutleryBtn;
var widthField;
var depthField;
var cutleryResults;
var widthtrimrequired = false
var depthtrimrequired = false
let genSt = "";

const CutleryUnits = [
  {
    name: "Joseph Joseph blox 10-piece drawer organiser set grey",
    width: 525,
    maxwidth: 525,
    depth: 440,
    maxdepth: 440,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/joseph-joseph-blox-10-piece-drawer-organiser-set-grey-soko-and-co-6.jpg?v=1677912500",
    url: "https://soko.com.au/products/joseph-joseph-blox-10-piece-drawer-organiser-set-grey",
    description: "Cutlery tray with clever, modular design that makes it ideal for a range of drawer sizes..",
    dimensions: "Width: 525mm, Depth: 440mm"
  },
  {
    name: "Joseph Joseph blox 7-piece drawer organiser set grey",
    width: 265,
    maxwidth: 265,
    depth: 440,
    maxdepth: 440,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/joseph-joseph-blox-7-piece-drawer-organiser-set-grey-soko-and-co-4.jpg?v=1677912487",
    url: "https://soko.com.au/products/joseph-joseph-blox-7-piece-drawer-organiser-set-grey",
    description: "Cutlery tray with clever, modular design that makes it ideal for a range of drawer sizes.",
    dimensions: "Width: 265mm, Depth: 440mm"
  },
  {
    name: "Sky 5 compartment custom-fit cutlery tray grey",
    width: 410,
    maxwidth: 450,
    depth: 460,
    maxdepth: 520,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/sky-wide-5-compartment-custom-fit-cutlery-tray-grey-soko-and-co.jpg?v=1677909996",
    url: "https://soko.com.au/products/sky-5-compartment-custom-fit-cutlery-tray-grey",
    description: "Featuring 5 sections perfect for holding utensils of any size, the high sides will keep your cutlery from spilling into other compartments.",
    dimensions: "Width: 450mm, Depth: 520mm"
  },
  {
    name: "Sky 5 compartment custom-fit cutlery tray white",
    width: 410,
    maxwidth: 450,
    depth: 460,
    maxdepth: 520,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/sky-wide-5-compartment-custom-fit-cutlery-tray-white-soko-and-co.jpg?v=1677909982",
    url: "https://soko.com.au/products/sky-5-compartment-custom-fit-cutlery-tray-white",
    description: "Featuring 5 sections perfect for holding utensils of any size, the high sides will keep your cutlery from spilling into other compartments.",
    dimensions: "Width: 450mm, Depth: 520mm"
  },
  {
    name: "Sky 4 compartment custom-fit cutlery tray grey",
    width: 360,
    maxwidth: 400,
    depth: 460,
    maxdepth: 520,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/sky-4-compartment-custom-fit-cutlery-tray-grey-soko-and-co.jpg?v=1677909985",
    url: "https://soko.com.au/products/sky-4-compartment-custom-fit-cutlery-tray-grey",
    description: "Featuring 4 sections perfect for holding utensils of any size, the high sides will keep your cutlery from spilling into other compartments.",
    dimensions: "Width: 400mm, Depth: 520mm"

  },
  {
    name: "Sky 4 compartment custom-fit cutlery tray white",
    width: 360,
    maxwidth: 400,
    depth: 460,
    maxdepth: 520,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/sky-4-compartment-custom-fit-cutlery-tray-white-soko-and-co.jpg?v=1677909967",
    url: "https://soko.com.au/products/sky-4-compartment-custom-fit-cutlery-tray-white",
    description: "Featuring 4 sections perfect for holding utensils of any size, the high sides will keep your cutlery from spilling into other compartments.",
    dimensions: "Width: 400mm, Depth: 520mm"
  },

  // -------------------- Idesign Linus--------------------------
  {
    name: "iDesign Linus Small Square Drawer Organiser",
    width: 75,
    maxwidth: 75,
    depth: 75,
    maxdepth:75,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/idesign-linus-small-square-drawer-organiser-soko-and-co.jpg?v=1677906325",
    url: "https://soko.com.au/products/idesign-linus-small-square-drawer-organiser",
    description: "With over 20 sizes and shapes available in the collection, you can finally fit all of your cutlery, utensils, knives and other kitchen accessories perfectly in your drawer.",
    dimensions: "Width: 75mm, Depth: 75mm"
  },
  {
    name: "iDesign Linus Small Drawer Organiser",
    width: 75,
    maxwidth: 75,
    depth: 163,
    maxdepth: 163,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/idesign-linus-small-drawer-organiser-soko-and-co.jpg?v=1677906628",
    url: "https://soko.com.au/products/idesign-linus-small-drawer-organiser",
    description: "With over 20 sizes and shapes available in the collection, you can finally fit all of your cutlery, utensils, knives and other kitchen accessories perfectly in your drawer.",
    dimensions: "Width: 75mm, Depth: 163mm"
  },
  {
    name: "iDesign Linus Medium Drawer Organiser",
    width: 80,
    maxwidth: 80,
    depth: 250,
    maxdepth: 250,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/idesign-linus-medium-drawer-organiser-soko-and-co.jpg?v=1677907508",
    url: "https://soko.com.au/products/idesign-linus-medium-drawer-organiser",
    description: "With over 20 sizes and shapes available in the collection, you can finally fit all of your cutlery, utensils, knives and other kitchen accessories perfectly in your drawer.",
    dimensions: "Width: 80mm, Depth: 250mm"
  },
  {
    name: "iDesign Linus Large Drawer Organiser",
    width: 75,
    maxwidth: 75,
    depth: 325,
    maxdepth: 325,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/idesign-linus-large-drawer-organiser-soko-and-co.jpg?v=1677906269",
    url: "https://soko.com.au/products/idesign-linus-large-drawer-organiser",
    description: "With over 20 sizes and shapes available in the collection, you can finally fit all of your cutlery, utensils, knives and other kitchen accessories perfectly in your drawer.",
    dimensions: "Width: 75mm, Depth: 325mm"
  },
  {
    name: "iDesign Linus Large Square Drawer Organiser",
    width: 150,
    maxwidth: 150,
    depth: 150,
    maxdepth: 150,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/idesign-linus-large-square-drawer-organiser-soko-and-co.jpg?v=1677906630",
    url: "https://soko.com.au/products/idesign-linus-large-square-drawer-organiser",
    description: "With over 20 sizes and shapes available in the collection, you can finally fit all of your cutlery, utensils, knives and other kitchen accessories perfectly in your drawer.",
    dimensions: "Width: 150mm, Depth: 150mm"
  },

  
  {
    name: "iDesign Linus Small Wide Drawer Organiser",
    width: 150,
    maxwidth: 150,
    depth: 230,
    maxdepth: 230,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/idesign-linus-small-wide-drawer-organiser-soko-and-co.jpg?v=1677912208",
    url: "https://soko.com.au/products/idesign-linus-small-wide-drawer-organiser",
    description: "With over 20 sizes and shapes available in the collection, you can finally fit all of your cutlery, utensils, knives and other kitchen accessories perfectly in your drawer.",
    dimensions: "Width: 150mm, Depth: 230mm"
  },
  {
    name: "iDesign Linus Medium Wide Drawer Organiser",
    width: 150,
    maxwidth: 150,
    depth: 305,
    maxdepth: 305,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/idesign-linus-medium-wide-drawer-organiser-soko-and-co.jpg?v=1677906634",
    url: "https://soko.com.au/products/idesign-linus-medium-wide-drawer-organiser",
    description: "With over 20 sizes and shapes available in the collection, you can finally fit all of your cutlery, utensils, knives and other kitchen accessories perfectly in your drawer.",
    dimensions: "Width: 150mm, Depth: 305mm"
  },
  {
    name: "iDesign Linus Large Wide Drawer Organiser",
    width: 150,
    maxwidth: 150,
    depth: 380,
    maxdepth: 380,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/idesign-linus-large-wide-drawer-organiser-soko-and-co.jpg?v=1677906640",
    url: "https://soko.com.au/products/idesign-linus-large-wide-drawer-organiser",
    description: "With over 20 sizes and shapes available in the collection, you can finally fit all of your cutlery, utensils, knives and other kitchen accessories perfectly in your drawer.",
    dimensions: "Width: 150mm, Depth: 380mm"
  },
  {
    name: "iDesign Linus Small Twin Drawer Organiser",
    width: 150,
    maxwidth: 150,
    depth: 230,
    maxdepth: 230,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/idesign-linus-small-twin-drawer-organiser-soko-and-co.jpg?v=1677905935",
    url: "https://soko.com.au/products/idesign-linus-small-twin-drawer-organiser",
    description: "With over 20 sizes and shapes available in the collection, you can finally fit all of your cutlery, utensils, knives and other kitchen accessories perfectly in your drawer.",
    dimensions: "Width: 150mm, Depth: 230mm"
  },
  {
    name: "iDesign Linus Large Twin Drawer Organiser",
    width: 150,
    maxwidth: 150,
    depth: 380,
    maxdepth: 380,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/idesign-linus-large-twin-drawer-organiser-soko-and-co.jpg?v=1677907499",
    url: "https://soko.com.au/products/idesign-linus-large-twin-drawer-organiser",
    description: "With over 20 sizes and shapes available in the collection, you can finally fit all of your cutlery, utensils, knives and other kitchen accessories perfectly in your drawer.",
    dimensions: "Width: 150mm, Depth: 380mm"
  },

  {
    name: "iDesign Linus Deep Square Drawer Organiser Small",
    width: 100,
    maxwidth: 100,
    depth: 100,
    maxdepth: 100,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/idesign-linus-deep-square-drawer-organiser-small-soko-and-co.jpg?v=1677906646",
    url: "https://soko.com.au/products/idesign-linus-deep-square-drawer-organiser-small",
    description: "With over 20 sizes and shapes available in the collection, you can finally fit all of your cutlery, utensils, knives and other kitchen accessories perfectly in your drawer.",
    dimensions: "Width: 100mm, Depth: 100mm"
  },
  {
    name: "iDesign Linus Small Deep Drawer Organiser",
    width: 100,
    maxwidth: 100,
    depth: 200,
    maxdepth: 200,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/idesign-linus-small-deep-drawer-organiser-soko-and-co.jpg?v=1677905905",
    url: "https://soko.com.au/products/idesign-linus-small-deep-drawer-organiser",
    description: "With over 20 sizes and shapes available in the collection, you can finally fit all of your cutlery, utensils, knives and other kitchen accessories perfectly in your drawer.",
    dimensions: "Width: 100mm, Depth: 200mm"
  },
  {
    name: "iDesign Linus Medium Deep Drawer Organiser",
    width: 100,
    maxwidth: 100,
    depth: 305,
    maxdepth: 305,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/idesign-linus-medium-deep-drawer-organiser-soko-and-co.jpg?v=1677906012",
    url: "https://soko.com.au/products/idesign-linus-medium-deep-drawer-organiser",
    description: "With over 20 sizes and shapes available in the collection, you can finally fit all of your cutlery, utensils, knives and other kitchen accessories perfectly in your drawer.",
    dimensions: "Width: 100mm, Depth: 305mm"
  },
  {
    name: "iDesign Linus Large Deep Drawer Organiser",
    width: 100,
    maxwidth: 100,
    depth: 405,
    maxdepth: 405,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/files/idesign-linus-large-deep-drawer-organiser-soko-and-co_2d5ae7f6-3d30-442a-a4be-f84a8907ffd0.jpg?v=1684401526",
    url: "https://soko.com.au/products/idesign-linus-large-deep-drawer-organiser",
    description: "With over 20 sizes and shapes available in the collection, you can finally fit all of your cutlery, utensils, knives and other kitchen accessories perfectly in your drawer.",
    dimensions: "Width: 100mm, Depth: 405mm"
  },
  {
    name: "iDesign Linus Acrylic 5 Compartment Cutlery Tray",
    width: 270,
    maxwidth: 270,
    depth: 350,
    maxdepth: 350,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/idesign-linus-acrylic-5-compartment-cutlery-tray-soko-and-co.jpg?v=1677906659",
    url: "https://soko.com.au/products/idesign-linus-acrylic-5-compartment-cutlery-tray",
    description: "With over 20 sizes and shapes available in the collection, you can finally fit all of your cutlery, utensils, knives and other kitchen accessories perfectly in your drawer.",
    dimensions: "Width: 270mm, Depth: 350mm"
  },
    // -------------------- Madesmart--------------------------

   {
    name: "Madesmart Grip Base Junk Drawer Organiser Carbon",
    width: 310,
    maxwidth: 310,
    depth: 370,
    maxdepth: 370,
    imageUrl: "https://soko.com.au/cdn/shop/files/madesmart-grip-base-junk-drawer-organiser-carbon-soko-and-co.jpg?v=1688204192&width=1000",
    url: "https://soko.com.au/products/madesmart-grip-base-junk-drawer-organiser-carbon",
    description: "It has four non-slip compartments that are great for storing everything from bottle openers and whisks to pens and staplers",
    dimensions: "Width: 310mm, Depth: 370mm"
  },
  {
    name: "Madesmart 6 Compartment Cutlery Tray Clear",
    width: 400,
    maxwidth: 400,
    depth: 330,
    maxdepth: 330,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-6-compartment-cutlery-tray-clear-soko-and-co.jpg?v=1677908436&width=1000",
    url: "https://soko.com.au/products/madesmart-6-compartment-cutlery-tray-clear",
    description: "This organiser is divided into 6 sections to keep your sets of spoons, forks, table knives, and extra silverware in a neat and orderly place. With soft-grip lining to prevent items from sliding around",
    dimensions: "Width: 400mm, Depth: 330mm"
  },
   {
    name: "Madesmart 3 Compartment Utensil Tray Clear",
    width: 400,
    maxwidth: 400,
    depth: 330,
    maxdepth: 330,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-3-compartment-utensil-tray-clear-soko-and-co.jpg?v=1677908444&width=1000",
    url: "https://soko.com.au/products/madesmart-3-compartment-utensil-tray-clear?variant=30292319207472",
    description: "Made with high-quality and transparent plastic for durable and quick visibility of all your kitchen utensils and gadgets. This sturdy container has 3 spacious compartments great for keeping your baking and cooking tools in one accessible place",
    dimensions: "Width: 400mm, Depth: 330mm"
  },
  {
    name: "Madesmart Medium Slim Grip Base Drawer Organiser Clear",
    width: 200,
    maxwidth: 200,
    depth: 85,
    maxdepth: 85,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-medium-slim-grip-base-drawer-organiser-clear-soko-and-co.jpg?v=1677908428&width=1000",
    url: "https://soko.com.au/products/madesmart-medium-slim-grip-base-drawer-organiser-clear?variant=30292318027824",
    description: "Keep your utensils and kitchen gadgets safe inside this Madesmart Clear Square Drawer Organiser Large. This deep and sturdy container will keep your tools safe yet accessible in the drawer",
    dimensions: "Width: 200mm, Depth: 85mm"
  },
   {
    name: "Madesmart Large Square Grip Base Drawer Organiser Clear",
    width: 250,
    maxwidth: 250,
    depth: 195,
    maxdepth: 195,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-large-square-grip-base-drawer-organiser-clear-soko-and-co.jpg?v=1677908467&width=1000",
    url: "https://soko.com.au/products/madesmart-large-square-grip-base-drawer-organiser-clear?variant=30292321140784",
    description: "Use the Madesmart Clear Square Drawer Organiser Large to set a special space for your kitchen gadgets. Separate your standard utensils from your kitchen tools for an organised area.",
    dimensions: "Width: 250mm, Depth: 195mm"
  },
  {
    name: "Madesmart Large Slim Grip Base Drawer Organiser Clear",
    width: 360,
    maxwidth: 360,
    depth: 95,
    maxdepth: 95,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-large-slim-grip-base-drawer-organiser-clear-soko-and-co.jpg?v=1677908459&width=1000",
    url: "https://soko.com.au/products/madesmart-large-slim-grip-base-drawer-organiser-clear?variant=30292320092208",
    description: "Protect your long-handled utensils and kitchen tools with the Madesmart Clear Slim Drawer Organiser Large. Designed for full visibility and accessibility!",
    dimensions: "Width: 360mm, Depth: 95mm"
  },
  {
    name: "Madesmart Large Wide Grip Base Drawer Organiser Clear",
    width: 400,
    maxwidth: 400,
    depth: 175,
    maxdepth: 175,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-large-wide-grip-base-drawer-organiser-clear-soko-and-co.jpg?v=1677908451&width=1000",
    url: "https://soko.com.au/products/madesmart-large-wide-grip-base-drawer-organiser-clear?variant=30292319666224",
    description: "Comes with generous space to carry your whisk, spatula, measuring spoon, pastry brush, and more. The soft-grip lining ensures that the content stays in place.",
    dimensions: "Width: 400mm, Depth: 175mm"
  },
  {
    name: "Madesmart Small Square Interlocking Drawer Organiser White",
    width: 80,
    maxwidth: 80,
    depth: 75,
    maxdepth: 75,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-small-square-interlocking-drawer-organiser-white-soko-and-co.jpg?v=1677907505&width=1000",
    url: "https://soko.com.au/products/madesmart-small-square-interlocking-drawer-organiser-white?variant=29042872188976",
    description: "Perfect for use in the kitchen for cutlery and utensils, in the bathroom for storing cosmetics and toiletries and in the office to declutter your stationery",
    dimensions: "Width: 80mm, Depth: 75mm"
  },
  {
    name: "Madesmart Medium Narrow Interlocking Drawer Organiser White",
    width: 80,
    maxwidth: 80,
    depth: 235,
    maxdepth: 235,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-medium-narrow-interlocking-drawer-organiser-white-soko-and-co.jpg?v=1677905958&width=450",
    url: "https://soko.com.au/products/madesmart-medium-narrow-interlocking-drawer-organiser-white?variant=16055917969466",
    description: "Perfect for use in the kitchen for cutlery and utensils, in the bathroom for storing cosmetics and toiletries and in the office to declutter your stationery",
    dimensions: "Width: 80mm, Depth: 235mm"
  },
  {
    name: "Madesmart Large Narrow Interlocking Drawer Organiser White",
    width: 80,
    maxwidth: 80,
    depth: 395,
    maxdepth: 395,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-large-narrow-interlocking-drawer-organiser-white-soko-and-co.jpg?v=1677905904&width=450",
    url: "https://soko.com.au/products/madesmart-large-narrow-interlocking-drawer-organiser-white?variant=16055429562426",
    description: "Perfect for use in the kitchen for cutlery and utensils, in the bathroom for storing cosmetics and toiletries and in the office to declutter your stationery.",
    dimensions: "Width: 80mm, Depth: 395mm"
  },
  {
    name: "Madesmart Medium Wide Interlocking Drawer Organiser White",
    width: 160,
    maxwidth: 160,
    depth: 235,
    maxdepth: 235,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-medium-wide-interlocking-drawer-organiser-white-soko-and-co.jpg?v=1677906827&width=450",
    url: "https://soko.com.au/products/madesmart-medium-wide-interlocking-drawer-organiser-white?variant=16059456290874",
    description: "Perfect for use in the kitchen for cutlery and utensils, in the bathroom for storing cosmetics and toiletries and in the office to declutter your stationery.",
    dimensions: "Width: 160mm, Depth: 235mm"
  },
   {
    name: "Madesmart Large Wide Interlocking Drawer Organiser White",
    width: 160,
    maxwidth: 160,
    depth: 395,
    maxdepth: 395,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-large-wide-interlocking-drawer-organiser-white-soko-and-co.jpg?v=1677906828&width=450",
    url: "https://soko.com.au/products/madesmart-large-wide-interlocking-drawer-organiser-white?variant=16059461861434",
    description: "Keep your drawers organised with this Madesmart Wide Drawer Organiser. The Madesmart range lets you mix and match different sized interlocking drawer organisers, making it the perfect way to keep your kitchen, bathroom and office drawers in tip-top condition!",
    dimensions: "Width: 160mm, Depth: 395mm"
  },
  {
    name: "Madesmart Small Square Interlocking Drawer Organiser Carbon",
    width: 85,
    maxwidth: 85,
    depth: 85,
    maxdepth: 85,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-small-square-interlocking-drawer-organiser-carbon-soko-and-co.jpg?v=1688204219&width=1000",
    url: "https://soko.com.au/products/madesmart-small-square-interlocking-drawer-organiser-carbon?variant=43141548245236",
    description: "Keep your drawers organised with this Madesmart Square Interlocking Drawer Organiser Small in Carbon. Use this tray with others in the range to create the perfect custom drawer organiser for your cutlery, utensils, stationery, makeup tools and more.",
    dimensions: "Width: 85mm, Depth: 85mm"
  },
  {
    name: "Madesmart Medium Narrow Interlocking Drawer Organiser Carbon",
    width: 85,
    maxwidth: 85,
    depth: 245,
    maxdepth: 245,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-medium-narrow-interlocking-drawer-organiser-carbon-soko-and-co.jpg?v=1688204225&width=1000",
    url: "https://soko.com.au/products/madesmart-medium-narrow-interlocking-drawer-organiser-carbon?variant=43141548343540",
    description: "Keep your drawers organised with this Madesmart Narrow Interlocking Drawer Organiser Medium in Carbon. Use this tray with others in the range to create the perfect custom drawer organiser for your cutlery, utensils, stationery, makeup tools and more.",
    dimensions: "Width: 85mm, Depth: 245mm"
  },
   {
    name: "Madesmart Large Narrow Interlocking Drawer Organiser Carbon",
    width: 85,
    maxwidth: 85,
    depth: 325,
    maxdepth: 325,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-large-narrow-interlocking-drawer-organiser-carbon-soko-and-co.jpg?v=1688204243&width=1000",
    url: "https://soko.com.au/products/madesmart-large-narrow-interlocking-drawer-organiser-carbon?variant=43141548703988",
    description: "Keep your drawers organised with this Madesmart Narrow Interlocking Drawer Organiser Large in Carbon. Use this tray with others in the range to create the perfect custom drawer organiser for your cutlery, utensils, stationery, makeup tools and more.",
    dimensions: "Width: 85mm, Depth: 325mm"
  },
  {
    name: "Madesmart Medium Wide Interlocking Drawer Organiser Carbon",
    width: 165,
    maxwidth: 165,
    depth: 245,
    maxdepth: 245,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-medium-wide-interlocking-drawer-organiser-carbon-soko-and-co.jpg?v=1688204231&width=1000",
    url: "https://soko.com.au/products/madesmart-medium-wide-interlocking-drawer-organiser-carbon?variant=43141548540148",
    description: "Keep your drawers organised with this Madesmart Wide Interlocking Drawer Organiser Medium in Carbon. Use this tray with others in the range to create the perfect custom drawer organiser for your cutlery, utensils, stationery, makeup tools and more.",
    dimensions: "Width: 165mm, Depth: 245mm"
  },
   {
    name: "Madesmart Large Wide Interlocking Drawer Organiser Carbon",
    width: 165,
    maxwidth: 165,
    depth: 405,
    maxdepth: 405,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-large-wide-interlocking-drawer-organiser-carbon-soko-and-co.jpg?v=1688204237&width=1000",
    url: "https://soko.com.au/products/madesmart-large-wide-interlocking-drawer-organiser-carbon?variant=43141548671220",
    description: "he drawer organiser has a non-slip inner and an interlocking edge, allowing you to attach it to other interlocking trays. This extra large organising tray is perfect for storing spoons, whisks, kitchen gadgets, stationery and makeup tools.",
    dimensions: "Width: 165mm, Depth: 405mm"
  },
  {
   name: "Madesmart Medium Wide Interlocking Drawer Organiser Carbon",
    width: 165,
    maxwidth: 165,
    depth: 245,
    maxdepth: 245,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-medium-wide-interlocking-drawer-organiser-carbon-soko-and-co.jpg?v=1688204231&width=1000",
    url: "https://soko.com.au/products/madesmart-medium-wide-interlocking-drawer-organiser-carbon?variant=43141548540148",
    description: "Keep your drawers organised with this Madesmart Wide Interlocking Drawer Organiser Medium in Carbon. Use this tray with others in the range to create the perfect custom drawer organiser for your cutlery, utensils, stationery, makeup tools and more.",
    dimensions: "Width: 165mm, Depth: 245mm"
  },
   {
    name: "Madesmart Mini 5 Compartment Grip Base Cutlery Tray Carbon",
    width: 325,
    maxwidth: 325,
    depth: 235,
    maxdepth: 235,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-mini-5-compartment-grip-base-cutlery-tray-carbon-soko-and-co.jpg?v=1686042510&width=1000",
    url: "https://soko.com.au/products/madesmart-mini-5-compartment-grip-base-cutlery-tray-carbon?variant=42746820460788",
    description: "Keep your cutlery and utensils organised with this Madesmart Mini 5 Compartment Cutlery Tray in Carbon. It's the perfect way to keep your cutlery and utensils at your fingertips!Made from durable plastic, this drawer organiser features a rubber-lined interior that stops your drawer contents from rattling around. Ideal for smaller drawers, this mini cutlery tray features 5 compartments, providing plenty of room for your utensils. Each compartment has high sides to prevent knives, forks and spoons from spilling into the wrong section. Non-slip rubber spots on the base will keep the cutlery tray in place and protect drawers from damage. Madesmart's new Carbon range features an antimicrobial additive that stops the growth of bacterial odours and extends the lifespan of your storage solutions. With Madesmart, your home can be kept organised AND perfectly hygienic for years to come!",
    dimensions: "Width: 325mm, Depth: 205mm"
  },
  {
    name: "Madesmart Mini 5 Compartment Grip Base Cutlery Tray White",
    width: 325,
    maxwidth: 325,
    depth: 235,
    maxdepth: 235,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-mini-5-compartment-grip-base-cutlery-tray-white-soko-and-co.jpg?v=1677907496&width=1000",
    url: "https://soko.com.au/products/madesmart-mini-5-compartment-grip-base-cutlery-tray-white?variant=29042868682800",
    description: "Keep your cutlery and utensils organised with this Madesmart Mini 5 Compartment Cutlery Tray. It's the perfect way to keep your cutlery and utensils at your fingertips!Made from durable plastic, this drawer organiser features a rubber-lined interior which stops your drawer contents from rattling around. Ideal for smaller drawers, this mini cutlery tray features 5 compartments, providing plenty of room for your utensils.Each compartment has high sides to prevent knives, forks and spoons spilling into the wrong section. Non-slip rubber spots on the base will keep the cutlery tray in place and protect drawers from damage.",
    dimensions: "Width: 325mm, Depth: 205mm"
  },
  {
    name: "Madesmart Mini 2 Compartment Grip Base Utensil Tray White",
    width: 325,
    maxwidth: 325,
    depth: 235,
    maxdepth: 235,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-mini-2-compartment-grip-base-utensil-tray-white-soko-and-co.jpg?v=1677907510&width=1000",
    url: "https://soko.com.au/products/madesmart-mini-2-compartment-grip-base-utensil-tray-white?variant=29042872582192",
    description: "Keep your cutlery and utensils organised with this Madesmart Mini 2 Compartment Utensil Tray. It's the perfect way to keep your cutlery and utensils at your fingertips! Made from durable plastic, this drawer organiser features a rubber-lined interior which stops your drawer contents from rattling around. Ideal for smaller drawers, this mini cutlery tray features 2 large compartments, providing plenty of room for your utensils.Each compartment has high sides to prevent knives, forks and spoons spilling into the wrong section. Non-slip rubber spots on the base will keep the cutlery tray in place and protect drawers from damage.",
    dimensions: "Width: 325mm, Depth: 205mm"
  },
  {
    name: "Madesmart Mini 2 Compartment Grip Base Utensil Tray Carbon",
    width: 325,
    maxwidth: 325,
    depth: 235,
    maxdepth: 235,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-mini-2-compartment-grip-base-utensil-tray-carbon-soko-and-co.jpg?v=1688200692&width=1000",
    url: "https://soko.com.au/products/madesmart-mini-2-compartment-grip-base-utensil-tray-carbon?variant=42746822394100",
    description: "Keep your cutlery and utensils organised with this Madesmart Mini 2 Compartment Utensil Tray in Carbon. It's the perfect way to keep your cutlery and utensils at your fingertips! Made from durable plastic, this drawer organiser features a rubber-lined interior that stops your drawer contents from rattling around. Ideal for smaller drawers, this mini cutlery tray features 2 large compartments, providing plenty of room for your utensils. Each compartment has high sides to prevent knives, forks and spoons from spilling into the wrong section. Non-slip rubber spots on the base will keep the cutlery tray in place and protect drawers from damage. Madesmart's new Carbon range features an antimicrobial additive that stops the growth of bacterial odours and extends the lifespan of your storage solutions. With Madesmart, your home can be kept organised AND perfectly hygienic for years to come!",
    dimensions: "Width: 325mm, Depth: 205mm"
  },
   {
    name: "Madesmart Small 5 Compartment Grip Base Cutlery Tray White",
    width: 328,
    maxwidth: 328,
    depth: 290,
    maxdepth: 290,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-small-5-compartment-grip-base-cutlery-tray-white-soko-and-co.jpg?v=1677905962&width=1000",
    url: "https://soko.com.au/products/madesmart-small-5-compartment-grip-base-cutlery-tray-white?variant=16056037081146",
    description: "Keep your cutlery and utensils organised with this Madesmart 5 Compartment Grip Base Cutlery Tray. It's the perfect way to keep your cutlery and utensils at your fingertips! Made from durable plastic, this drawer organiser features a rubber-lined interior which stops your drawer contents from rattling around. Ideal for small to medium-sized drawers, this cutlery tray features 5 compartments, providing plenty of room for your utensils. Each compartment has high sides to prevent knives, forks and spoons spilling into the wrong section. Non-slip rubber spots on the base will keep the cutlery tray in place and protect drawers from damage.",
    dimensions: "Width: 328mm, Depth: 290mm"
  },
  {
    name: "Madesmart Small 5 Compartment Grip Base Cutlery Tray Carbon",
    width: 328,
    maxwidth: 328,
    depth: 290,
    maxdepth: 290,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-small-5-compartment-grip-base-cutlery-tray-carbon-soko-and-co.jpg?v=1688200464&width=1000",
    url: "https://soko.com.au/products/madesmart-small-5-compartment-grip-base-cutlery-tray-carbon?variant=42746816233716",
    description: "Keep your cutlery and utensils organised with this Madesmart 5 Compartment Grip Base Cutlery Tray in Carbon. It's the perfect way to keep your cutlery and utensils at your fingertips! Made from durable plastic, this drawer organiser features a rubber-lined interior that stops your drawer contents from rattling around. Ideal for small to medium-sized drawers, this cutlery tray features 5 compartments, providing plenty of room for your utensils. Each compartment has high sides to prevent knives, forks and spoons from spilling into the wrong section. Non-slip rubber spots on the base will keep the cutlery tray in place and protect drawers from damage. Madesmart's new Carbon range features an antimicrobial additive that stops the growth of bacterial odours and extends the lifespan of your storage solutions. With Madesmart, your home can be kept organised AND perfectly hygienic for years to come!",
    dimensions: "Width: 328mm, Depth: 290mm"
  },
  {
    name: "Madesmart 6 Compartment Grip Base Cutlery Tray White",
    width: 330,
    maxwidth: 330,
    depth: 405,
    maxdepth: 405,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-6-compartment-grip-base-cutlery-tray-white-soko-and-co.jpg?v=1677906072&width=1000",
    url: "https://soko.com.au/products/madesmart-6-compartment-grip-base-cutlery-tray-white?variant=16056753160250",
    description: "Keep your cutlery and utensils organised with this Madesmart 6 Compartment Grip Base Cutlery Tray. It's the perfect way to keep your cutlery and utensils at your fingertips! Made from durable plastic, this drawer organiser features a rubber-lined interior which stops your drawer contents from rattling around. Ideal for medium to large-sized drawers, this cutlery tray features 5 long compartments and one rectangular compartment, which is plenty of room for utensils and cutlery of any size. Each compartment has high sides to prevent knives, forks and spoons spilling into the wrong section. Non-slip rubber feet on the base will keep the cutlery tray in place and protect drawers from damage.",
    dimensions: "Width: 330mm, Depth: 405mm"
  },
  {
    name: "Madesmart 6 Compartment Grip Base Cutlery Tray Carbon",
    width: 330,
    maxwidth: 330,
    depth: 405,
    maxdepth: 405,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-6-compartment-grip-base-cutlery-tray-carbon-soko-and-co.jpg?v=1688200643&width=1000",
    url: "https://soko.com.au/products/madesmart-6-compartment-grip-base-cutlery-tray-carbon?variant=42746821017844",
    description: "Keep your cutlery and utensils organised with this Madesmart 6 Compartment Grip Base Cutlery Tray in Carbon. It's the perfect way to keep your cutlery and utensils at your fingertips! Made from durable plastic, this drawer organiser features a rubber-lined interior which stops your drawer contents from rattling around. Ideal for medium to large-sized drawers, this cutlery tray features 5 long compartments and one rectangular compartment, which is plenty of room for utensils and cutlery of any size. Each compartment has high sides to prevent knives, forks and spoons spilling into the wrong section. Non-slip rubber feet on the base will keep the cutlery tray in place and protect drawers from damage. Madesmart's new Carbon range features an antimicrobial additive that stops the growth of bacterial odours and extends the lifespan of your storage solutions. With Madesmart, your home can be kept organised AND perfectly hygienic for years to come!",
    dimensions: "Width: 330mm, Depth: 405mm"
  },
  {
    name: "Madesmart 3 Compartment Grip Base Utensil Tray White",
    width: 330,
    maxwidth: 330,
    depth: 405,
    maxdepth: 405,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-3-compartment-grip-base-utensil-tray-white-soko-and-co.jpg?v=1677906534&width=1000",
    url: "https://soko.com.au/products/madesmart-3-compartment-grip-base-utensil-tray-white?variant=16058106839098",
    description: "Keep your cutlery and utensils organised with this Madesmart 3 Compartment Grip Base Utensil Tray. It's the perfect way to keep your cutlery and utensils at your fingertips! Made from durable plastic, this drawer organiser features a rubber-lined interior which stops your drawer contents from rattling around. Ideal for medium to large-sized drawers, this cutlery tray features 3 long, wide compartments which offer plenty of room for utensils and cutlery of any size. Each compartment has high sides to prevent utensils and gadgets spilling into the wrong section. Non-slip rubber feet on the base will keep the cutlery tray in place and protect drawers from damage.",
    dimensions: "Width: 330mm, Depth: 405mm"
  },
  {
    name: "Madesmart 3 Compartment Grip Base Utensil Tray Carbon",
    width: 330,
    maxwidth: 330,
    depth: 405,
    maxdepth: 405,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-3-compartment-grip-base-utensil-tray-carbon-soko-and-co.jpg?v=1688200502&width=1000",
    url: "https://soko.com.au/products/madesmart-3-compartment-grip-base-utensil-tray-carbon?variant=42746817183988",
    description: "Keep your cutlery and utensils organised with this Madesmart 6 Compartment Grip Base Cutlery Tray in Carbon. It's the perfect way to keep your cutlery and utensils at your fingertips! Made from durable plastic, this drawer organiser features a rubber-lined interior that stops your drawer contents from rattling around. Ideal for medium to large-sized drawers, this cutlery tray features 5 long compartments and one rectangular compartment, which is plenty of room for utensils and cutlery of any size. Each compartment has high sides to prevent knives, forks and spoons from spilling into the wrong section. Non-slip rubber feet on the base will keep the cutlery tray in place and protect drawers from damage. Madesmart's new Carbon range features an antimicrobial additive that stops the growth of bacterial odours and extends the lifespan of your storage solutions. With Madesmart, your home can be kept organised AND perfectly hygienic for years to come!",
    dimensions: "Width: 330mm, Depth: 405mm"
  },
   {
    name: "Madesmart Grip Base Junk Drawer Organiser White",
    width: 310,
    maxwidth: 310,
    depth: 370,
    maxdepth: 370,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-grip-base-junk-drawer-organiser-white-soko-and-co.jpg?v=1688208923&width=1000",
    url: "https://soko.com.au/products/madesmart-grip-base-junk-drawer-organiser-white?variant=43311604629748",
    description: "Easily keep your kitchen or office drawers decluttered with this Madesmart Junk Drawer Organiser in White & Grey. It has four non-slip compartments that are great for storing everything from bottle openers and whisks to pens and staplers.",
    dimensions: "Width: 310mm, Depth: 370mm"
  },
   {
    name: "Madesmart Small In-Drawer Knife Mat Carbon",
    width: 105,
    maxwidth: 105,
    depth: 385,
    maxdepth: 385,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-small-in-drawer-knife-mat-carbon-soko-and-co.jpg?v=1688204255&width=1000",
    url: "https://soko.com.au/products/madesmart-small-in-drawer-knife-mat-carbon?variant=43141549588724",
    description: "Safely organise knives in your kitchen drawers with this Madesmart In-Drawer Knife Mat Small in Carbon. This small knife organiser fits perfectly inside most drawers and includes a non-slip base to keep your blades sharp and organised. With 5 divided slots for your knives, the blades will be safe from damage. The non-slip silicone base will keep the knife holder safe from slipping and sliding around when the drawer is opened. Madesmart's Carbon range features an antimicrobial additive that stops the growth of bacterial odours and extends the lifespan of your storage solutions. With Madesmart, your home can be kept organised AND perfectly hygienic for years to come!",
    dimensions: "Width: 105mm, Depth: 385mm"
  },
   {
    name: "Madesmart Small In-Drawer Knife Mat White",
    width: 105,
    maxwidth: 105,
    depth: 385,
    maxdepth: 385,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-small-in-drawer-knife-mat-white-soko-and-co.jpg?v=1684298819&width=1000",
    url: "https://soko.com.au/products/madesmart-small-in-drawer-knife-mat-white?variant=16056235196474",
    description: "Keep your drawers organised with Madesmart's In-Drawer Knife Mat. Now you can keep your knives and drawers perfectly organised, thanks to Madesmart. Crafted from durable plastic, this small knife organiser fits perfectly inside most drawers and includes a non-slip base to keep your blades sharp and organised. With 5 separate slots for storage, your knives will be protected from any blade damage, and the non-slip silicone mat will make sure your knife collection doesn't move around when the drawer is opened or closed.",
    dimensions: "Width: 105mm, Depth: 385mm"
  },
  {
    name: "Madesmart 8 Compartment Expandable Grip Base Cutlery Tray White",
    width: 337,
    maxwidth: 540,
    depth: 405,
    maxdepth: 405,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-8-compartment-expandable-grip-base-cutlery-tray-white-soko-and-co.jpg?v=1677906537&width=1000",
    url: "https://soko.com.au/products/madesmart-8-compartment-expandable-grip-base-cutlery-tray-white?variant=16058111262778",
    description: "Keep your cutlery and utensils organised with this Madesmart Expandable 8 Compartment Cutlery Tray. It's the perfect way to keep your cutlery and utensils at your fingertips! Made from durable plastic, this drawer organiser features a rubber-lined interior which stops your drawer contents from rattling around. The 2 side panels expand in 2.5cm increments, up to a maximum width of 54cm. Ideal for large, wide drawers, this cutlery tray features 6 standard compartments, plus 2 long compartments when both sides are expanded. Plenty of room for utensils and cutlery of any size! Each compartment has high sides to prevent utensils and gadgets spilling into the wrong section. Non-slip rubber feet on the base will keep the cutlery tray in place and protect drawers from damage.",
    dimensions: "Width: 337mm - 540mm, Depth: 405mm"
  },
  {
    name: "Madesmart 8 Compartment Expandable Grip Base Cutlery Tray Carbon",
    width: 337,
    maxwidth: 540,
    depth: 405,
    maxdepth: 405,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-8-compartment-expandable-grip-base-cutlery-tray-carbon-soko-and-co.jpg?v=1688200739&width=1000",
    url: "https://soko.com.au/products/madesmart-8-compartment-expandable-grip-base-cutlery-tray-carbon",
    description: "Keep your cutlery and utensils organised with this Madesmart Expandable 8 Compartment Cutlery Tray in Carbon. It's the perfect way to keep your cutlery and utensils at your fingertips! Made from durable plastic, this drawer organiser features a rubber-lined interior that stops your drawer contents from rattling around. The 2 side panels expand in 2.5cm increments, up to a maximum width of 54cm. Ideal for large, wide drawers, this cutlery tray features 6 standard compartments, plus 2 long compartments when both sides are expanded. Plenty of room for utensils and cutlery of any size! Each compartment has high sides to prevent utensils and gadgets from spilling into the wrong section. Non-slip rubber feet on the base will keep the cutlery tray in place and protect drawers from damage. Madesmart's new Carbon range features an antimicrobial additive that stops the growth of bacterial odours and extends the lifespan of your storage solutions. With Madesmart, your home can be kept organised AND perfectly hygienic for years to come!",
    dimensions: "Width: 337mm - 540mm, Depth: 405mm"
  },
  {
    name: "Madesmart 5 Compartment Expandable Grip Base Utensil Tray White",
    width: 337,
    maxwidth: 540,
    depth: 405,
    maxdepth: 405,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-5-compartment-expandable-grip-base-utensil-tray-white-soko-and-co.jpg?v=1677906311&width=1000",
    url: "https://soko.com.au/products/madesmart-5-compartment-expandable-grip-base-utensil-tray-white?variant=16057342427194",
    description: "Keep your cutlery and utensils organised with this Madesmart Expandable 5 Compartment Utensil Tray. It's the perfect way to keep your cutlery and utensils at your fingertips! Made from durable plastic, this drawer organiser features a rubber-lined interior which stops your drawer contents from rattling around. The 2 side panels expand in 2.5cm increments, up to a maximum width of 54cm. Ideal for large, wide drawers, this cutlery tray features 5 long compartments when both sides are expanded, which offer plenty of room for utensils and cutlery of any size. Each compartment has high sides to prevent utensils and gadgets spilling into the wrong section. Non-slip rubber feet on the base will keep the cutlery tray in place and protect drawers from damage.",
    dimensions: "Width: 337mm - 540mm, Depth: 405mm"
  },
  {
    name: "Madesmart 5 Compartment Expandable Grip Base Utensil Tray Carbon",
    width: 337,
    maxwidth: 540,
    depth: 405,
    maxdepth: 405,
    imageUrl: "https://soko.com.au/cdn/shop/files/madesmart-5-compartment-expandable-grip-base-utensil-tray-carbon-soko-and-co.jpg?v=1688200682&width=1000",
    url: "https://soko.com.au/products/madesmart-5-compartment-expandable-grip-base-utensil-tray-carbon",
    description: "Keep your cutlery and utensils organised with this Madesmart Expandable 5 Compartment Utensil Tray in Carbon. It's the perfect way to keep your cutlery and utensils at your fingertips! Made from durable plastic, this drawer organiser features a rubber-lined interior that stops your drawer contents from rattling around. The 2 side panels expand in 2.5cm increments, up to a maximum width of 54cm. Ideal for large, wide drawers, this cutlery tray features 5 long compartments when both sides are expanded, which offer plenty of room for utensils and cutlery of any size. Each compartment has high sides to prevent utensils and gadgets from spilling into the wrong section. Non-slip rubber feet on the base will keep the cutlery tray in place and protect drawers from damage.Madesmart's new Carbon range features an antimicrobial additive that stops the growth of bacterial odours and extends the lifespan of your storage solutions. With Madesmart, your home can be kept organised AND perfectly hygienic for years to come!",
    dimensions: "Width: 337mm - 540mm, Depth: 405mm"
  },
  {
    name: "Madesmart Small Grip Base Drawer Organiser White",
    width: 95,
    maxwidth: 95,
    depth: 250,
    maxdepth: 250,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-small-grip-base-drawer-organiser-white-soko-and-co.jpg?v=1677906529&width=1000",
    url: "https://soko.com.au/products/madesmart-small-grip-base-drawer-organiser-white?variant=16058103529530",
    description: "Keep your cutlery and utensils organised with this Madesmart Grip Base Drawer Organiser. It's the perfect way to keep cutlery and utensils at your fingertips! Made from durable plastic, this drawer organiser features a rubber-lined interior which stops your drawer contents from rattling around. This drawer organiser is perfect for knives, forks, spoons and kitchen accessories like bottle openers and peelers. Mix and match with the rest of the Madesmart Drawer Organiser range to create your very own custom cutlery storage solution. Non-slip rubber feet on the base will keep the cutlery tray in place and protect drawers from damage.",
    dimensions: "Width: 95mm, Depth: 250mm"
  },
    {
    name: "Madesmart Small Grip Base Drawer Organiser Carbon",
    width: 95,
    maxwidth: 95,
    depth: 250,
    maxdepth: 250,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-small-grip-base-drawer-organiser-carbon-soko-and-co.jpg?v=1686042458&width=1000",
    url: "https://soko.com.au/products/madesmart-small-grip-base-drawer-organiser-carbon",
    description: "Keep your cutlery and utensils organised with this Madesmart Grip Base Drawer Organiser in Carbon. It's the perfect way to keep cutlery and utensils at your fingertips! Made from durable plastic, this drawer organiser features a rubber-lined interior that stops your drawer contents from rattling around. This drawer organiser is perfect for knives, forks, spoons and kitchen accessories like bottle openers and peelers. Mix and match with the rest of the Madesmart Drawer Organiser range to create your very own custom cutlery storage solution. Non-slip rubber feet on the base will keep the cutlery tray in place and protect drawers from damage. Madesmart's new Carbon range features an antimicrobial additive that stops the growth of bacterial odours and extends the lifespan of your storage solutions. With Madesmart, your home can be kept organised AND perfectly hygienic for years to come!",
    dimensions: "Width: 95mm, Depth: 250mm"
  },
   {
    name: "Madesmart Medium Grip Base Drawer Organiser White",
    width: 170,
    maxwidth: 170,
    depth: 250,
    maxdepth: 250,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-medium-grip-base-drawer-organiser-white-soko-and-co.jpg?v=1677905981&width=1000",
    url: "https://soko.com.au/products/madesmart-medium-grip-base-drawer-organiser-white?variant=16056215502906",
    description: "Keep your cutlery and utensils organised with this Madesmart Grip Base Drawer Organiser. It's the perfect way to keep cutlery and utensils at your fingertips! Made from durable plastic, this drawer organiser features a rubber-lined interior which stops your drawer contents from rattling around. This drawer organiser is perfect for knives, forks, spoons and kitchen accessories like bottle openers and peelers. Mix and match with the rest of the Madesmart Drawer Organiser range to create your very own custom cutlery storage solution. Non-slip rubber feet on the base will keep the cutlery tray in place and protect drawers from damage.",
    dimensions: "Width: 170mm, Depth: 250mm"
  },
  {
    name: "Madesmart Medium Grip Base Drawer Organiser Carbon",
    width: 170,
    maxwidth: 170,
    depth: 250,
    maxdepth: 250,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-medium-grip-base-drawer-organiser-carbon-soko-and-co.jpg?v=1686042451&width=1000",
    url: "https://soko.com.au/products/madesmart-medium-grip-base-drawer-organiser-carbon",
    description: "Keep your cutlery and utensils organised with this Madesmart Grip Base Drawer Organiser in Carbon. It's the perfect way to keep cutlery and utensils at your fingertips! Made from durable plastic, this drawer organiser features a rubber-lined interior that stops your drawer contents from rattling around. This drawer organiser is perfect for knives, forks, spoons and kitchen accessories like bottle openers and peelers. Mix and match with the rest of the Madesmart Drawer Organiser range to create your very own custom cutlery storage solution. Non-slip rubber feet on the base will keep the cutlery tray in place and protect drawers from damage. Madesmart's new Carbon range features an antimicrobial additive that stops the growth of bacterial odours and extends the lifespan of your storage solutions. With Madesmart, your home can be kept organised AND perfectly hygienic for years to come!",
    dimensions: "Width: 170mm, Depth: 250mm"
  },
   {
    name: "Madesmart Large Grip Base Drawer Organiser White",
    width: 168,
    maxwidth: 168,
    depth: 395,
    maxdepth: 395,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-large-grip-base-drawer-organiser-white-soko-and-co.jpg?v=1677906114&width=1000",
    url: "https://soko.com.au/products/madesmart-large-grip-base-drawer-organiser-white?variant=16056875384890",
    description: "Keep your cutlery and utensils organised with this Madesmart Grip Base Drawer Organiser. It's the perfect way to keep cutlery and utensils at your fingertips! Made from durable plastic, this drawer organiser features a rubber-lined interior which stops your drawer contents from rattling around. This drawer organiser is perfect for longer utensils like spoons, spatulas and chopsticks. Mix and match with the rest of the Madesmart Drawer Organiser range to create your very own custom cutlery storage solution. Non-slip rubber feet on the base will keep the cutlery tray in place and protect drawers from damage.",
    dimensions: "Width: 168mm, Depth: 395mm"
  },
   {
    name: "Madesmart Large Grip Base Drawer Organiser Carbon",
    width: 168,
    maxwidth: 168,
    depth: 395,
    maxdepth: 395,
    imageUrl: "https://soko.com.au/cdn/shop/products/madesmart-large-grip-base-drawer-organiser-carbon-soko-and-co.jpg?v=1688200421&width=1000",
    url: "https://soko.com.au/products/madesmart-large-grip-base-drawer-organiser-carbon",
    description: "Keep your cutlery and utensils organised with this Madesmart Grip Base Drawer Organiser in Carbon. It's the perfect way to keep cutlery and utensils at your fingertips! Made from durable plastic, this drawer organiser features a rubber-lined interior that stops your drawer contents from rattling around. This drawer organiser is perfect for longer utensils like spoons, spatulas and chopsticks. Mix and match with the rest of the Madesmart Drawer Organiser range to create your very own custom cutlery storage solution. Non-slip rubber feet on the base will keep the cutlery tray in place and protect drawers from damage. Madesmart's new Carbon range features an antimicrobial additive that stops the growth of bacterial odours and extends the lifespan of your storage solutions. With Madesmart, your home can be kept organised AND perfectly hygienic for years to come!",
    dimensions: "Width: 168mm, Depth: 395mm"
  },
  {
    name: "Umbra Peggy Pot & Lid Drawer Organiser 2 Pack Charcoal",
    width: 450,
    maxwidth: 610,
    depth: 450,
    maxdepth: 543,
    imageUrl: "https://soko.com.au/cdn/shop/products/umbra-peggy-pot-lid-drawer-organiser-2-pack-charcoal-soko-and-co.jpg?v=1677918020&width=1000",
    url: "https://soko.com.au/products/umbra-peggy-pot-lid-drawer-organiser-2-pack-charcoal?variant=43800711856372",
    description: "Organising large kitchen items just got easier, thanks to this Umbra Peggy Pot & Lid Drawer Organiser 2 Pack in Charcoal. The removable pegs simply click into the two adjustable bases to create the perfect custom kitchen organising rack. There are 16 pegs included and 108 base holes for them to attach to, creating hundreds of possible configurations for storing your pots, pans, mixing bowls, chopping boards and lids. Each base has non-slip feet and expands up to 8.25cm, allowing you to perfectly fit them inside your drawers or cupboards.",
    dimensions: "Width: 450mm - 610mm, Depth: 543mm"
  },
  {
    name: "Joseph Joseph DrawerStore Expandable Cutlery Tray Grey",
    width: 285,
    maxwidth: 480,
    depth: 365,
    maxdepth: 365,
    imageUrl: "https://soko.com.au/cdn/shop/products/joseph-joseph-drawerstore-expandable-cutlery-tray-grey-soko-and-co.jpg?v=1677907413&width=1000",
    url: "https://soko.com.au/products/joseph-joseph-drawerstore-expandable-cutlery-tray-grey?variant=28591685861424",
    description: "Organise your messy cutlery drawer with Joseph Joseph DrawerStore Expandable Cutlery Tray in Grey! This kitchen drawer organiser is the perfect way to organise those messy cutlery drawers. It has four deep-sided compartments that separate your knives, forks, spoons and larger utensils. Expandable up to 48cm in width, this utensil tray is made from durable PP which is perfect for busy kitchens. Say goodbye to your unruly cutlery drawer, and hello to organised utensils!",
    dimensions: "Width: 285mm - 480mm, Depth: 365mm"
  },
   {
    name: "Joseph Joseph DrawerStore Compact Cutlery Tray Grey",
    width: 398,
    maxwidth: 398,
    depth: 114,
    maxdepth: 114,
    imageUrl: "https://soko.com.au/cdn/shop/products/joseph-joseph-drawerstore-compact-cutlery-tray-grey-soko-and-co.jpg?v=1677907415&width=1000",
    url: "https://soko.com.au/products/joseph-joseph-drawerstore-compact-cutlery-tray-grey?variant=28591686254640",
    description: "Do you have a messy, unorganised and cluttered cutlery drawer? Tired of incomplete sets of cutlery? Organise your messy cutlery drawer with Joseph Joseph DrawerStore Compact Cutlery Tray Slim! You need neat storage for your spoons, forks and knives. This innovative cutlery tray is especially designed to storage-challenged, small-spaced kitchens. This ultra-narrow cutlery canteen is so slim, it'll fit down the side of any kitchen drawer, yet there's room inside for a multitude of full-sized knives, forks, spoons and teaspoons. With its angling and layering features, it's easier to find specific cutlery with ease. Each compartment has a handy cutlery icon to help you remember what cutlery to store where and has plenty of space to insert your cutlery either handle first or head first. With its compact feature, it can easily fit drawer spaces! Goodbye unruly cutlery drawer, say hello to organised utensils with the cleverly designed Joseph Joseph DrawerStore Compact Cutlery Tray!",
    dimensions: "Width: 398mm, Depth: 114mm"
  },
  {
    name: "Joseph Joseph DrawerStore Compact In Drawer Knife Rack Grey",
    width: 398,
    maxwidth: 398,
    depth: 143,
    maxdepth: 143,
    imageUrl: "https://soko.com.au/cdn/shop/products/joseph-joseph-drawerstore-compact-in-drawer-knife-rack-grey-soko-and-co.jpg?v=1677905872&width=1000",
    url: "https://soko.com.au/products/joseph-joseph-drawerstore-compact-in-drawer-knife-rack-grey?variant=16055202480186",
    description: "Don't know where to store your knives? Does it add up to the clutter in your utensils drawer? Here's a great item to help you safely keep your knives in a neat storage! Store your sharp knives safely with Joseph Joseph DrawerStore Knife Organiser! This compact 2-tier knife organiser saves space in your cutlery drawer and provides a safe solution for keeping knives in kitchen drawers. Leaving them loose can be dangerous and can also damage the blades, whereas this 2-tier organiser gives you easy and safe access to them while protecting the blades by stacking them over two levels securely. The two levels differ in blade length capacity and can hold up to nine knives in total. Non-slip feet are also featured at the bottom, making sure it's steady and secure. The Joseph Joseph DrawerStore Knife Organiser will not only keep your knives safely away from curious kids, but also keep your countertop free of clutter!",
    dimensions: "Width: 398mm, Depth: 143mm"
  },
   {
    name: "Joseph Joseph DrawerStore Wide Compact Cutlery Tray Grey",
    width: 175,
    maxwidth: 175,
    depth: 395,
    maxdepth: 395,
    imageUrl: "https://soko.com.au/cdn/shop/products/joseph-joseph-drawerstore-wide-compact-cutlery-tray-grey-soko-and-co.jpg?v=1677910124&width=1000",
    url: "https://soko.com.au/products/joseph-joseph-drawerstore-wide-compact-cutlery-tray-grey?variant=32270751268912",
    description: "Do you have a messy, unorganised and cluttered cutlery drawer? Tired of incomplete sets of cutlery? Organise your messy cutlery drawer with Joseph Joseph DrawerStore Compact Cutlery Tray Large! You need neat storage for your spoons, forks and knives. This innovative and space-saving cutlery tray is especially designed for small kitchens and tight spaces. This compact cutlery organiser is perfect for small drawers while allowing you to store full-sized knives, forks, spoons and teaspoons.With its clever angled design, it's easier to find specific cutlery with ease. Each compartment has a handy cutlery icon to help you remember what cutlery to store where and has plenty of space to insert your cutlery either handle first or head first. With its compact design, it can easily fit drawers of any size! Goodbye unruly cutlery drawer, say hello to organised utensils with the cleverly designed Joseph Joseph DrawerStore Compact Cutlery Tray!",
    dimensions: "Width: 175mm, Depth: 395mm"
  },
  {
    name: "Joseph Joseph Bamboo 2-Tier Knife Organiser Large",
    width: 176,
    maxwidth: 176,
    depth: 396,
    maxdepth: 396,
    imageUrl: "https://soko.com.au/cdn/shop/files/joseph-joseph-bamboo-2-tier-knife-organiser-large-soko-and-co.jpg?v=1708852991&width=1000",
    url: "https://soko.com.au/products/joseph-joseph-bamboo-2-tier-knife-organiser-large?variant=44602017186036",
    description: "Don't know where to store your knives? Does it add up to the clutter in your utensils drawer? Here's a great item to help you safely keep your knives in a neat storage! Store your sharp knives safely with Joseph Joseph Bamboo 2-Tier Knife Organiser Large! This compact 2-tier knife organiser saves space in your cutlery drawer and provides a safe solution for keeping knives in kitchen drawers. Leaving them loose can be dangerous and can also damage the blades, whereas this 2-tier organiser gives you easy and safe access to them while protecting the blades by stacking them over two levels securely. The two levels differ in blade length capacity and can hold up to nine knives in total. Non-slip feet are also featured at the bottom, making sure it's steady and secure. The Joseph Joseph Bamboo Knife Organiser will not only keep your knives safely away from curious kids, but also keep your countertop free of clutter!",
    dimensions: "Width: 176mm, Depth: 396mm"
  },
  {
    name: "Joseph Joseph Expandable Bamboo Cutlery and Utensil Organiser",
    width: 560,
    maxwidth: 560,
    depth: 400,
    maxdepth: 400,
    imageUrl: "https://soko.com.au/cdn/shop/files/joseph-joseph-bamboo-2-tier-knife-organiser-large-soko-and-co.jpg?v=1708852991&width=1000",
    url: "https://soko.com.au/products/joseph-joseph-bamboo-2-tier-knife-organiser-large?variant=44602017186036",
    description: "Don't know where to store your knives? Does it add up to the clutter in your utensils drawer? Here's a great item to help you safely keep your knives in a neat storage! Store your sharp knives safely with Joseph Joseph Bamboo 2-Tier Knife Organiser Large! This compact 2-tier knife organiser saves space in your cutlery drawer and provides a safe solution for keeping knives in kitchen drawers. Leaving them loose can be dangerous and can also damage the blades, whereas this 2-tier organiser gives you easy and safe access to them while protecting the blades by stacking them over two levels securely. The two levels differ in blade length capacity and can hold up to nine knives in total. Non-slip feet are also featured at the bottom, making sure it's steady and secure. The Joseph Joseph Bamboo Knife Organiser will not only keep your knives safely away from curious kids, but also keep your countertop free of clutter!",
    dimensions: "Width: 560mm, Depth: 400mm"
  },
  {
    name: "Joseph Joseph DrawerStore Wide Compact Cutlery Tray Bamboo",
    width: 175,
    maxwidth: 175,
    depth: 384,
    maxdepth: 384,
    imageUrl: "https://soko.com.au/cdn/shop/files/joseph-joseph-drawerstore-wide-compact-cutlery-tray-bamboo-soko-and-co.jpg?v=1709371230&width=1000",
    url: "https://soko.com.au/products/joseph-joseph-drawerstore-wide-compact-cutlery-tray-bamboo?variant=44602016497908",
    description: "Do you have a messy, unorganised and cluttered cutlery drawer? Tired of incomplete sets of cutlery? Organise your messy cutlery drawer with Joseph Joseph Bamboo Cutlery Organiser Large You need neat storage for your spoons, forks and knives. This innovative and space-saving cutlery tray is especially designed for small kitchens and tight spaces. This compact cutlery organiser is perfect for small drawers while allowing you to store full-sized knives, forks, spoons and teaspoons. With its clever angled design, it's easier to find specific cutlery with ease. Each compartment has a handy cutlery icon to help you remember what cutlery to store where and has plenty of space to insert your cutlery either handle first or head first. With its compact design, it can easily fit drawers of any size! Goodbye unruly cutlery drawer, say hello to organised utensils with the cleverly designed Joseph Joseph Bamboo Cutlery Organiser Large",
    dimensions: "Width: 175mm, Depth: 384mm"
  },
  {
    name: "Joseph Joseph Blox 7 Piece Drawer Organiser Set Grey",
    width: 265,
    maxwidth: 265,
    depth: 440,
    maxdepth: 440,
    imageUrl: "https://soko.com.au/cdn/shop/products/joseph-joseph-blox-7-piece-drawer-organiser-set-grey-soko-and-co.jpg?v=1677912485&width=1000",
    url: "https://soko.com.au/products/joseph-joseph-blox-7-piece-drawer-organiser-set-grey?variant=40156572483784",
    description: "If you've struggled to find the right drawer organiser for your cutlery or utensils, this Joseph Joseph Blox 7 Piece Cutlery Tray Set Grey could be the solution you've been looking for. It has a clever, modular design that makes it ideal for a range of drawer sizes. Complete with 7 modular trays that clip together, you can easily create your very own custom drawer storage solution. Easily arrange as many trays as you need in any configuration that suits your cutlery, utensils, stationery, makeup or craft accessories. If you have extra-large drawers, you can even join together multiple sets. Included in each set are self-adhesive non-slip feet, ensuring that your brand new Joseph Joseph drawer insert stays put!",
    dimensions: "Width: 265mm, Depth: 440mm"
  },
  {
    name: "Joseph Joseph Blox 10 Piece Drawer Organiser Set Grey",
    width: 525,
    maxwidth: 525,
    depth: 440,
    maxdepth: 440,
    imageUrl: "https://soko.com.au/cdn/shop/products/joseph-joseph-blox-10-piece-drawer-organiser-set-grey-soko-and-co.jpg?v=1677912495&width=1000",
    url: "https://soko.com.au/products/joseph-joseph-blox-10-piece-drawer-organiser-set-grey?variant=40156572680392",
    description: "If you've struggled to find the right drawer organiser for your cutlery or utensils, this Joseph Joseph Blox 10 Piece Cutlery Tray Set Grey could be the solution you've been looking for. It has a clever, modular design that makes it ideal for a range of drawer sizes. Complete with 10 modular trays that clip together, you can easily create your very own custom drawer storage solution. Easily arrange as many trays as you need in any configuration that suits your cutlery, utensils, stationery, makeup or craft accessories. If you have extra-large drawers, you can even join together multiple sets. Included in each set are self-adhesive non-slip feet, ensuring that your brand new Joseph Joseph drawer insert stays put!",
    dimensions: "Width: 525mm, Depth: 440mm"
  },
  {
    name: "The Sophie Cutlery Drawer Insert Set",
    width: 410,
    maxwidth: 410,
    depth: 410,
    maxdepth: 410,
    imageUrl: "https://soko.com.au/cdn/shop/files/the-sophie-cutlery-drawer-insert-set-soko-and-co.jpg?v=1720431170&width=1000",
    url: "https://soko.com.au/products/the-sophie-cutlery-drawer-insert-set?variant=45045588066548",
    description: "Take the guesswork out of fitting your cutlery drawers with The Sophie Cutlery Drawer Inserts Set. Our new cutlery tray insert kits make creating a custom drawer easier than ever before. Expertly chosen, these cutlery trays won't fall short when organising your drawers. Our Cutlery Drawer Insert Sets come in a wide range of unique sizes based on the most common drawers on the market, meaning they fit almost any drawer! Using the industry favourite Linus Drawer Organisers, these cutlery drawers don't compromise style or functionality. The clear utensil and cutlery trays are a seamless addition to your drawers, no matter the colour. They are also easy to clean and can be popped into warm, soapy water to come out sparkling like new. Kitchen drawer organisation has never been easier with these amazing cutlery trays!  Not quite the right size? Size up or down for your perfect fit! Or, if you've got a little gap, add a single piece from the Linus Drawer Organisers to fill in the space. ",
    dimensions: "Width: 410mm, Depth: 410mm"
  },
  {
    name: "The Charlie Cutlery Drawer Insert Set",
    width: 410,
    maxwidth: 410,
    depth: 410,
    maxdepth: 410,
    imageUrl: "https://soko.com.au/cdn/shop/files/the-charlie-cutlery-drawer-insert-set-soko-and-co.jpg?v=1720430969&width=1000",
    url: "https://soko.com.au/products/the-charlie-cutlery-drawer-insert-set?variant=45045126365428",
    description: "Take the guesswork out of fitting your cutlery drawers with The Charlie Cutlery Drawer Inserts Set. Our new cutlery tray insert kits make creating a custom drawer easier than ever before. Expertly chosen, these cutlery trays won't fall short when organising your drawers. Our Cutlery Drawer Insert Sets come in a wide range of unique sizes based on the most common drawers on the market, meaning they fit almost any drawer! Using the industry favourite Linus Drawer Organisers, these cutlery drawers don't compromise style or functionality. The clear utensil and cutlery trays are a seamless addition to your drawers, no matter the colour. They are also easy to clean and can be popped into warm, soapy water to come out sparkling like new. Not quite the right size? Size up or down for your perfect fit! Or, if you've got a little gap, add a single piece from the Linus Drawer Organisers to fill in the space. ",
    dimensions: "Width: 410mm, Depth: 410mm"
  },
   {
    name: "The Trina Cutlery Drawer Inserts Set",
    width: 492,
    maxwidth: 492,
    depth: 415,
    maxdepth: 415,
    imageUrl: "https://soko.com.au/cdn/shop/files/the-trina-cutlery-drawer-inserts-set-soko-and-co.jpg?v=1720432542&width=1000",
    url: "https://soko.com.au/products/the-trina-cutlery-drawer-inserts-set?variant=45104142876916",
    description: "Take the guesswork out of fitting your cutlery drawers with The Trina Cutlery Drawer Inserts Set. Our new cutlery tray insert kits make creating a custom drawer easier than ever before. Expertly chosen, these cutlery trays won't fall short when organising your drawers. Our Cutlery Drawer Insert Sets come in a wide range of unique sizes based on the most common drawers on the market, meaning they fit almost any drawer! Using the industry favourite Linus Drawer Organisers, these cutlery drawers don't compromise style or functionality. The clear utensil and cutlery trays are a seamless addition to your drawers, no matter the colour. They are also easy to clean and can be popped into warm, soapy water to come out sparkling like new. Kitchen drawer organisation has never been easier with these amazing cutlery trays! Not quite the right size? Size up or down for your perfect fit! Or, if you've got a little gap, add a single piece from the Linus Drawer Organisers to fill in the space.",
    dimensions: "Width: 492mm, Depth: 415mm"
  },
  {
    name: "The Maria Cutlery Drawer Inserts Set",
    width: 738,
    maxwidth: 738,
    depth: 415,
    maxdepth: 415,
    imageUrl: "https://soko.com.au/cdn/shop/files/the-maria-cutlery-drawer-inserts-set-soko-and-co.jpg?v=1720431518&width=1000",
    url: "https://soko.com.au/products/the-maria-cutlery-drawer-inserts-set?variant=45104138289396",
    description: "Take the guesswork out of fitting your cutlery drawers with The Maria Cutlery Drawer Inserts Set. Our new cutlery tray insert kits make creating a custom drawer easier than ever before. Expertly chosen, these cutlery trays won't fall short when organising your drawers. Our Cutlery Drawer Insert Sets come in a wide range of unique sizes based on the most common drawers on the market, meaning they fit almost any drawer! Using the industry favourite Linus Drawer Organisers, these cutlery drawers don't compromise style or functionality. The clear utensil and cutlery trays are a seamless addition to your drawers, no matter the colour. They are also easy to clean and can be popped into warm, soapy water to come out sparkling like new. Kitchen drawer organisation has never been easier with these amazing cutlery trays! Not quite the right size? Size up or down for your perfect fit! Or, if you've got a little gap, add a single piece from the Linus Drawer Organisers to fill in the space. ",
    dimensions: "Width: 738mm, Depth: 415mm"
  },
  {
    name: "The Cameron Cutlery Drawer Inserts Set",
    width: 492,
    maxwidth: 492,
    depth: 412,
    maxdepth: 412,
    imageUrl: "https://soko.com.au/cdn/shop/files/the-cameron-cutlery-drawer-inserts-set-soko-and-co.jpg?v=1720431729&width=1000",
    url: "https://soko.com.au/products/the-cameron-cutlery-drawer-inserts-set?variant=45104139763956",
    description: "Take the guesswork out of fitting your cutlery drawers with The Cameron Cutlery Drawer Inserts Set. Our new cutlery tray insert kits make creating a custom drawer easier than ever before. Expertly chosen, these cutlery trays won't fall short when organising your drawers. Our Cutlery Drawer Insert Sets come in a wide range of unique sizes based on the most common drawers on the market, meaning they fit almost any drawer! Using the industry favourite Linus Drawer Organisers, these cutlery drawers don't compromise style or functionality. The clear utensil and cutlery trays are a seamless addition to your drawers, no matter the colour. They are also easy to clean and can be popped into warm, soapy water to come out sparkling like new. Kitchen drawer organisation has never been easier with these amazing cutlery trays! Not quite the right size? Size up or down for your perfect fit! Or, if you've got a little gap, add a single piece from the Linus Drawer Organisers to fill in the space. ",
    dimensions: "Width: 492mm, Depth: 412mm"
  },
  {
    name: "The Sammy Cutlery Drawer Insert Set",
    width: 415,
    maxwidth: 415,
    depth: 500,
    maxdepth: 500,
    imageUrl: "https://soko.com.au/cdn/shop/files/the-sammy-cutlery-drawer-insert-set-soko-and-co.jpg?v=1720517672&width=1000",
    url: "https://soko.com.au/products/the-sammy-cutlery-drawer-insert-set?variant=45088536264948",
    description: "Take the guesswork out of fitting your cutlery drawers with The Sammy Cutlery Drawer Inserts Set. Our new cutlery tray insert kits make creating a custom drawer easier than ever before. Expertly chosen, these cutlery trays won't fall short when organising your drawers.Our Cutlery Drawer Insert Sets come in a wide range of unique sizes based on the most common drawers on the market, meaning they fit almost any drawer! Using the industry favourite Linus Drawer Organisers, these cutlery drawers don't compromise style or functionality. The clear utensil and cutlery trays are a seamless addition to your drawers, no matter the colour. They are also easy to clean and can be popped into warm, soapy water to come out sparkling like new. Kitchen drawer organisation has never been easier with these amazing cutlery trays! Not quite the right size? Size up or down for your perfect fit! Or, if you've got a little gap, add a single piece from the Linus Drawer Organisers to fill in the space. ",
    dimensions: "Width: 415mm, Depth: 500mm"
  },
   {
    name: "The Theo Cutlery Drawer Inserts Set",
    width: 575,
    maxwidth: 575,
    depth: 415,
    maxdepth: 415,
    imageUrl: "https://soko.com.au/cdn/shop/files/the-theo-cutlery-drawer-inserts-set-soko-and-co.jpg?v=1720431941&width=1000",
    url: "https://soko.com.au/products/the-theo-cutlery-drawer-inserts-set?variant=45104140255476",
    description: "Take the guesswork out of fitting your cutlery drawers with The Theo Cutlery Drawer Inserts Set. Our new cutlery tray insert kits make creating a custom drawer easier than ever before. Expertly chosen, these cutlery trays won't fall short when organising your drawers. Our Cutlery Drawer Insert Sets come in a wide range of unique sizes based on the most common drawers on the market, meaning they fit almost any drawer! Using the industry favourite Linus Drawer Organisers, these cutlery drawers don't compromise style or functionality. The clear utensil and cutlery trays are a seamless addition to your drawers, no matter the colour. They are also easy to clean and can be popped into warm, soapy water to come out sparkling like new. Kitchen drawer organisation has never been easier with these amazing cutlery trays! Not quite the right size? Size up or down for your perfect fit! Or, if you've got a little gap, add a single piece from the Linus Drawer Organisers to fill in the space. ",
    dimensions: "Width: 575mm, Depth: 415mm"
  },
  {
    name: "Bamboo Kitchen Drawer Dividers 2 Pack",
    width: 30,
    maxwidth: 30,
    depth: 465,
    maxdepth: 465,
    imageUrl: "https://soko.com.au/cdn/shop/products/bamboo-kitchen-drawer-dividers-2-pack-soko-and-co.jpg?v=1697519164&width=1000",
    url: "https://soko.com.au/products/bamboo-kitchen-drawer-dividers-2-pack?variant=32275138084912",
    description: "Customise your kitchen drawers with these brilliant pack of 2 Bamboo Dream Drawer Dividers for Kitchen Drawers. With a sturdy spring-loaded design, your messy drawers will be a thing of the past! These drawer dividers are the perfect way to organise your large utensils or junk drawer. Quickly and efficiently customise your drawers by adding the right amount of dividers for your needs. With a sturdy spring-loaded mechanism, these drawer dividers expand up to 57cm to perfectly fit your drawer and will stay put, even with repeated opening of the drawer. These bamboo drawer inserts are perfect for keeping your kitchen utensils, gadgets, cutlery, dish towels, spice jars or small kitchen containers neat and tidy within your drawer! These Bamboo Dream Drawer Dividers Bedroom are also available for deeper kitchen drawers or to keep your socks, underwear and accessories decluttered in your wardrobe.",
    dimensions: "Width: 30mm, Depth: 465mm"
  },
  {
    name: "12 Piece Adjustable Bamboo Drawer Divider",
    width: 445,
    maxwidth: 560,
    depth: 445,
    maxdepth: 560,
    imageUrl: "https://soko.com.au/cdn/shop/files/12-piece-adjustable-bamboo-drawer-divider-soko-and-co.jpg?v=1700904178&width=1000",
    url: "https://soko.com.au/products/12-piece-adjustable-bamboo-drawer-divider?variant=44322055586036",
    description: "Sick of buying drawer dividers, coming home and realising they don't fit? The 12 Piece Adjustable Bamboo Drawer Divider is the perfect fit for almost every drawer! With adjustable inserts and spring-loaded dividers, this 12-piece set makes organisation easy. With adjustable inserts, this drawer divider kit can be used for every drawer in your home. Create small sections for your socks and jocks in the bedroom, or create long sections for cutlery in the kitchen. And for the extra tall drawers, these dividers can be stacked atop each other. No matter the need, this kit will work everywhere. ",
    dimensions: "Width: 445mm - 560mm, Depth: 445mm - 560mm "
  },
  {
    name: "5 Compartment Bamboo Cutlery Tray",
    width: 255,
    maxwidth: 225,
    depth: 352,
    maxdepth: 352,
    imageUrl: "https://soko.com.au/cdn/shop/products/5-compartment-bamboo-cutlery-tray-soko-and-co.jpg?v=1697522119&width=1000",
    url: "https://soko.com.au/products/5-compartment-bamboo-cutlery-tray?variant=43853240271092",
    description: "Organise your kitchen drawers with this 5 Compartment Bamboo Cutlery Tray. It's the perfect way to keep your cutlery and utensils at your fingertips! Made from durable and environmentally-friendly bamboo, this drawer organiser is perfect for small to medium-sized kitchen drawers. There are four large cutlery sections that are great for knives, forks, spoons and other large utensils, along with a shorter compartment for teaspoons and kitchen gadgets. Each compartment has high sides to prevent knives, forks and spoons from spilling into the wrong section.",
    dimensions: "Width: 255mm, Depth: 352mm"
  },
   {
    name: "Soko Cutlery Tray 500mm",
    width: 450,
    maxwidth: 450,
    depth: 490,
    maxdepth: 490,
    imageUrl: "https://soko.com.au/cdn/shop/files/soko-cutlery-tray-500mm-soko-and-co.jpg?v=1732526377&width=800",
    url: "https://soko.com.au/products/soko-cutlery-tray-500mm?variant=45983255396596",
    description: "Transform your kitchen drawers with our thoughtfully designed cutlery trays. Available in timeless white with a matt finish, these trays offer the perfect combination of elegance and practicality for modern homes. Expertly crafted to fit 450mm deep drawers, they cater to carcase widths from 400mm to 900mm, ensuring a seamless fit for a variety of configurations. The sleek design is not just about aesthetics—it’s also about functionality. The anti-slip bottom pattern keeps your cutlery neatly in place, even when drawers are opened and closed, while the contemporary style adds a refined touch to your kitchen space. Whether you're organizing everyday utensils or showcasing premium flatware, these cutlery trays deliver a polished, clutter-free solution that suits any kitchen interior. Showcasing a dedication to quality and design, these drawers represent the upgrade you have been waiting for.",
    dimensions: "Width: 450mm, Depth: 490mm"
  },
  {
    name: "Mera 8 Compartment Expandable Cutlery Tray Bamboo",
    width: 300,
    maxwidth: 420,
    depth: 380,
    maxdepth: 380,
    imageUrl: "https://soko.com.au/cdn/shop/files/mera-8-compartment-expandable-cutlery-tray-bamboo-soko-and-co_52d8e021-fbd5-465b-8be1-568e87e818f9.jpg?v=1725960320&width=1000",
    url: "https://soko.com.au/products/mera-8-compartment-expandable-cutlery-tray-bamboo?variant=45715610665204",
    description: "Can't find a cutlery tray that fits? Take the guesswork out of choosing the right size tray and opt for the Mera 8 Compartment Expandable Cutlery Tray. The easy-to-use slide-out cutlery tray expands to fit the dimensions of your drawer. This cutlery draw insert is a practical space-saving organiser that ensures your kitchen drawers always stay neat and tidy. Once expanded, this cutlery holder won't slide around or shift, and stays expanded to your elected width. The 8 sections include space for even your largest cutlery and homes your tiniest teaspoons. The larger compartments can even be utilised for your daily utensils. End the cutlery tray hunt and take the next step to a perfectly organised home. Nobody has time to fuss over trying dozens of cutlery trays, so save your time and energy and choose the Mera Expandable Cutlery Tray.",
    dimensions: "Width: 300mm - 420mm , Depth: 380mm "
  },
  {
    name: "Uni Fit Adjustable Compact Cutlery Tray Grey",
    width: 150,
    maxwidth: 150,
    depth: 390,
    maxdepth: 490,
    imageUrl: "https://soko.com.au/cdn/shop/products/uni-fit-adjustable-compact-cutlery-tray-grey-soko-and-co.jpg?v=1681291524&width=1000",
    url: "https://soko.com.au/products/uni-fit-adjustable-compact-cutlery-tray-grey?variant=43854567407860",
    description: "Get those messy cutlery drawers organised with this Uni Fit Adjustable Compact Cutlery Tray in Grey. This drawer organiser is expandable and includes three adjustable dividers, making it perfect for any kitchen drawer. Expandable from 39-49cm in depth, you can easily store a complete cutlery set in this utensil tray. The clever angled design saves space while keeping knives, forks and spoons easy to access. The three small sections at the top of the cutlery tray are ideal for teaspoons, bottle openers and other small kitchen gadgets. The three large dividers can be removed, allowing you to store larger cooking tools like spatulas and whisks.",
    dimensions: "Width: 150mm, Depth: 390mm - 490mm"
  },
   {
    name: "Linea Utensil Tray Grey 520 x 550mm",
    width: 520,
    maxwidth: 520,
    depth: 550,
    maxdepth: 550,
    imageUrl: "https://soko.com.au/cdn/shop/files/linea-utensil-tray-grey-520-x-550mm-soko-and-co.jpg?v=1732094827&width=800",
    url: "https://soko.com.au/products/linea-utensil-tray-grey-520-x-550mm?variant=45983255494900",
    description: "Need some extra help organisation your kitchen draweers? The Linea Utensil Tray acts as a perfectly versatile and stylish organizer designed to bring order back to your kitchen. Crafted with precision and a focus on quality, the Linea Utensil Tray is now available in a sleek slate grey finish and a practical 520 x 550mm size. Its multi-purpose layout is enhanced with optional slot-in dividers, allowing you to customise compartments to suit your utensils and streamline your kitchen organization. With an effective execution of design and durability, the Linea Utensil Tray offers a smart, stylish, and functional solution for any modern kitchen. Get your hands on yet another effective kitchen storage solutions ",
    dimensions: "Width: 520mm, Depth: 550mm"
  },
   {
    name: "Linea Utensil Tray Grey 510 x 570mm",
    width: 510,
    maxwidth: 510,
    depth: 750,
    maxdepth: 750,
    imageUrl: "https://soko.com.au/cdn/shop/files/linea-utensil-tray-grey-510-x-570mm-soko-and-co.jpg?v=1732094814&width=800",
    url: "https://soko.com.au/products/linea-utensil-tray-grey-510-x-570mm?variant=45983255232756",
    description: "Need some extra help organisation your kitchen drawers? The Linea Utensil Tray acts as a perfectly versatile and stylish organiser designed to bring order back to your kitchen. Crafted with precision and a focus on quality, the Linea Utensil Tray is now available in a sleek slate grey finish and a practical 510 x 750mm size. Its multi-purpose layout is enhanced with optional slot-in dividers, allowing you to customise compartments to suit your utensils and streamline your kitchen organization. With an effective execution of design and durability, the Linea Utensil Tray offers a smart, stylish, and functional solution for any modern kitchen. Get your hands on yet another effective kitchen storage solutions ",
    dimensions: "Width: 510mm, Depth: 750mm"
  },
   {
    name: "Linea Utensil Tray Grey 850 x 510mm",
    width: 85,
    maxwidth: 85,
    depth: 510,
    maxdepth: 510,
    imageUrl: "https://soko.com.au/cdn/shop/files/linea-utensil-tray-grey-850-x-510mm-soko-and-co.jpg?v=1732526373&width=800",
    url: "https://soko.com.au/products/linea-utensil-tray-grey-850-x-510mm?variant=45983255265524",
    description: "Need some extra help organisation your kitchen drawers? The Linea Utensil Tray acts as a perfectly versatile and stylish organizer designed to bring order back to your kitchen. Crafted with precision and a focus on quality, the Linea Utensil Tray is now available in a sleek slate grey finish and a practical 85 x 510mm size. Its multi-purpose layout is enhanced with optional slot-in dividers, allowing you to customise compartments to suit your utensils and streamline your kitchen organisation. With an effective execution of design and durability, the Linea Utensil Tray offers a smart, stylish, and functional solution for any modern kitchen. Get your hands on yet another effective kitchen storage solutions ",
    dimensions: "Width: 85mm, Depth: 510mm"
  },

  
  {
    name: "Sky 5 Compartment Custom Fit Cutlery Tray White",
    width: 410,
    maxwidth: 450,
    depth: 460,
    maxdepth: 520,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/sky-5-compartment-custom-fit-cutlery-tray-white-soko-and-co.jpg?v=1677909971",
    url: "https://soko.com.au/products/sky-5-compartment-custom-fit-cutlery-tray-white?variant=32118379053104",
    description: "Made from thick, reinforced plastic and made in Germany, this cutlery tray is very easy to keep clean. Featuring 5 sections perfect for holding utensils of any size, the high sides will keep your cutlery from spilling into other compartments.",
    dimensions: "Width: 410mm - 450mm , Depth: 460mm - 520mm"
  },
  {
    name: "Sky 5 Compartment Custom Fit Cutlery Tray Grey",
    width: 410,
    maxwidth: 450,
    depth: 460,
    maxdepth: 520,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/sky-5-compartment-custom-fit-cutlery-tray-grey-soko-and-co.jpg?v=1677909969",
    url: "https://soko.com.au/products/sky-5-compartment-custom-fit-cutlery-tray-grey?variant=32118378987568",
    description: "Made from thick, reinforced plastic and made in Germany, this cutlery tray is very easy to keep clean. Featuring 5 sections perfect for holding utensils of any size, the high sides will keep your cutlery from spilling into other compartments.",
    dimensions: "Width: 410mm - 450mm , Depth: 460mm - 520mm"
  },
  {
    name: "Sky Wide 5 Compartment Custom Fit Cutlery Tray White",
    width: 510,
    maxwidth: 550,
    depth: 460,
    maxdepth: 510,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/sky-wide-5-compartment-custom-fit-cutlery-tray-white-soko-and-co.jpg",
    url: "https://soko.com.au/products/sky-wide-5-compartment-custom-fit-cutlery-tray-white",
    description: "Made from thick, reinforced plastic and made in Germany, this cutlery tray is very easy to keep clean. Featuring 5 sections perfect for holding utensils of any size, the high sides will keep your cutlery from spilling into other compartments.",
    dimensions: "Width: 510mm - 550mm , Depth: 460mm - 510mm"
  },
  {
    name: "Sky Wide 5 Compartment Custom Fit Cutlery Tray Grey",
    width: 510,
    maxwidth: 550,
    depth: 460,
    maxdepth: 510,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/sky-wide-5-compartment-custom-fit-cutlery-tray-grey-soko-and-co.jpg",
    url: "https://soko.com.au/products/sky-wide-5-compartment-custom-fit-cutlery-tray-grey?variant=32118383771696",
    description: "Made from thick, reinforced plastic and made in Germany, this cutlery tray is very easy to keep clean. Featuring 5 sections perfect for holding utensils of any size, the high sides will keep your cutlery from spilling into other compartments.",
    dimensions: "Width: 510mm - 550mm , Depth: 460mm - 510mm"
  },
  {
    name: "Sky 7 Compartment Custom Fit Cutlery Tray White",
    width: 610,
    maxwidth: 650,
    depth: 460,
    maxdepth: 510,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/sky-7-compartment-custom-fit-cutlery-tray-white-soko-and-co.jpg",
    url: "https://soko.com.au/products/sky-7-compartment-custom-fit-cutlery-tray-white",
    description: "Made from thick, reinforced plastic and made in Germany, this cutlery tray is very easy to keep clean. Featuring 5 sections perfect for holding utensils of any size, the high sides will keep your cutlery from spilling into other compartments.",
    dimensions: "Width: 610mm - 650mm , Depth: 460mm - 510mm"
  },
  {
    name: "Sky 7 Compartment Custom Fit Cutlery Tray Grey",
    width: 610,
    maxwidth: 650,
    depth: 460,
    maxdepth: 510,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/sky-7-compartment-custom-fit-cutlery-tray-grey-soko-and-co.jpg",
    url: "https://soko.com.au/products/sky-7-compartment-custom-fit-cutlery-tray-grey",
    description: "Made from thick, reinforced plastic and made in Germany, this cutlery tray is very easy to keep clean. Featuring 5 sections perfect for holding utensils of any size, the high sides will keep your cutlery from spilling into other compartments.",
    dimensions: "Width: 610mm - 650mm , Depth: 460mm - 510mm"
  },
  {
    name: "Sky 8 Compartment Custom Fit Cutlery Tray White",
    width: 710,
    maxwidth: 750,
    depth: 460,
    maxdepth: 510,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/sky-8-compartment-custom-fit-cutlery-tray-white-soko-and-co.jpg",
    url: "https://soko.com.au/products/sky-8-compartment-custom-fit-cutlery-tray-white",
    description: "Made from thick, reinforced plastic and made in Germany, this cutlery tray is very easy to keep clean. Featuring 5 sections perfect for holding utensils of any size, the high sides will keep your cutlery from spilling into other compartments.",
    dimensions: "Width: 710mm - 750mm , Depth: 460mm - 510mm"
  },
  {
    name: "Sky 8 Compartment Custom Fit Cutlery Tray Grey",
    width: 710,
    maxwidth: 750,
    depth: 460,
    maxdepth: 510,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/sky-8-compartment-custom-fit-cutlery-tray-grey-soko-and-co.jpg",
    url: "https://soko.com.au/products/sky-8-compartment-custom-fit-cutlery-tray-grey",
    description: "Made from thick, reinforced plastic and made in Germany, this cutlery tray is very easy to keep clean. Featuring 5 sections perfect for holding utensils of any size, the high sides will keep your cutlery from spilling into other compartments.",
    dimensions: "Width: 710mm - 750mm , Depth: 460mm - 510mm"
  },
  {
    name: "Sky 9 Compartment Custom Fit Cutlery Tray White",
    width: 810,
    maxwidth: 850,
    depth: 460,
    maxdepth: 510,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/sky-9-compartment-custom-fit-cutlery-tray-white-soko-and-co.jpg",
    url: "https://soko.com.au/products/sky-9-compartment-custom-fit-cutlery-tray-white",
    description: "Made from thick, reinforced plastic and made in Germany, this cutlery tray is very easy to keep clean. Featuring 5 sections perfect for holding utensils of any size, the high sides will keep your cutlery from spilling into other compartments.",
    dimensions: "Width: 810mm - 850mm , Depth: 460mm - 510mm"
  },
  {
    name: "Sky 9 Compartment Custom Fit Cutlery Tray Grey",
    width: 810,
    maxwidth: 850,
    depth: 460,
    maxdepth: 510,
    imageUrl: "https://cdn.shopify.com/s/files/1/0133/1970/0538/products/sky-9-compartment-custom-fit-cutlery-tray-grey-soko-and-co.jpg",
    url: "https://soko.com.au/products/sky-9-compartment-custom-fit-cutlery-tray-grey",
    description: "Made from thick, reinforced plastic and made in Germany, this cutlery tray is very easy to keep clean. Featuring 5 sections perfect for holding utensils of any size, the high sides will keep your cutlery from spilling into other compartments.",
    dimensions: "Width: 810mm - 850mm , Depth: 460mm - 510mm"
  },
  
    
  /*Add more Cutlery units as needed using the format in the data table excel file*/
];

// defer until page load
addEventListener("load", (event) => {
  // find elements
  findCutleryBtn = document.getElementById('findCutleryBtn');
  widthField = document.getElementById('width');
  depthField = document.getElementById('depth');
  cutleryResults = document.getElementById('cutleryResults');

  // initial state
  checkFieldsAndDisableButton();

  // on enter key pressed
  widthField.addEventListener("keyup", function (e) {
    if (e.key === "Enter" && !checkFields()) {
      console.log(e.key);
      calculateFittingCutleryUnits();
    } else {
      checkFieldsAndDisableButton();
    }
  });
  depthField.addEventListener("keyup", function (e) {
    if (e.key === "Enter" && !checkFields()) {
      calculateFittingCutleryUnits();
    } else {
      checkFieldsAndDisableButton();
    }
  });

  // on button press
  findCutleryBtn.addEventListener('click', calculateFittingCutleryUnits);
});

function checkFieldsAndDisableButton() {
  disableButton(checkFields());
}

function checkFields() {
  return (widthField.value == '' || depthField.value == '')
}

function disableButton(boolean) {
  if (boolean) {
    findCutleryBtn.disabled = true;
  } else {
    findCutleryBtn.disabled = false;
  }
}

function calculateFittingCutleryUnits() {
  const width = parseInt(document.getElementById('width').value);
  const depth = parseInt(document.getElementById('depth').value);
  var maxwidth = 0;
  var maxdepth = 0;
  var productwidth = 0;
  var productdepth = 0;
  const fittingCutleryUnits = CutleryUnits.filter(unit => {
    return unit.width <= width && unit.depth <= depth;
  });
  displayCutleryUnits(fittingCutleryUnits, width, depth, maxdepth, maxwidth, productwidth, productdepth);
}


function displayCutleryUnits(units, width, depth, maxwidth, maxdepth, productwidth, productdepth) {
  cutleryResults.innerHTML = '';
  if (units.length === 0) {
    cutleryResults.innerHTML = 'No Cutlery trays found for the specified dimensions.';
    return;
  }
  var i = 0;
  units.forEach(unit => {
    const productItem = document.createElement('div');

    productItem.classList.add('cutlery-product-item');

    const title = document.createElement('h3');
    title.textContent = unit.name;

    const link = document.createElement('a');
    link.href = unit.url;

    const img = document.createElement('img');
    img.width = 600;
    img.src = unit.imageUrl;
    img.alt = unit.name;
    i = i + 1;

    const description = document.createElement('p');
    description.textContent = unit.description;

    const dimensions = document.createElement('p');
    dimensions.textContent = unit.dimensions;

    const quantity = calculateQuantity(unit, width, depth);
    const quantityText = document.createElement('p');
    if (quantity > 1) {
      quantityText.textContent = `Quantity: ${quantity}`;
    }
    const trimtext = document.createElement('p');
    trimneeded(width, depth, unit.maxwidth, unit.maxdepth, unit.width, unit.depth, unit);
    if (widthtrimrequired || depthtrimrequired) {
      genSt += " requires trimming:"
      quantityText.textContent = `${genSt} ${quantity}`;
    }
    genSt = "";
    link.appendChild(title);
    link.appendChild(img);
    productItem.appendChild(title);
    productItem.appendChild(link);
    productItem.appendChild(description);
    productItem.appendChild(dimensions);
    productItem.appendChild(quantityText);
    cutleryResults.appendChild(productItem);
    widthtrimrequired = false;
    depthtrimrequired = false;

  });
}

function trimneeded(inputwidth, inputdepth, maxwidth, maxdepth, minwidth, mindepth, unit) {
  if (minwidth <= inputwidth && inputwidth < maxwidth) {
    console.log(mindepth, maxdepth, minwidth, maxwidth, `Name=${unit.name}`, inputwidth, inputdepth);
    widthtrimrequired = true;
    genSt += "Width";
  }

  if (mindepth <= inputdepth && inputdepth < maxdepth) {
    depthtrimrequired = true;
    console.log(`${unit.name} is withrequired =${widthtrimrequired}`);
    if (widthtrimrequired) {
      genSt += " and Depth";
    } else {
      genSt += "Depth";
    }
  }
}

function calculateQuantity(unit, width, depth) {
  const maxQuantitywidth = Math.floor(width / unit.width);
  const maxQuantitydepth = Math.floor(depth / unit.depth);
  return Math.min(maxQuantitywidth, maxQuantitydepth);
}